import { general } from './general';
import { radio } from './radio';
import { textarea } from './textarea';
import { text } from './text';
import { datecontrol } from './datecontrol';
import { notapplicable } from './notapplicable';
import { branch } from './branch';
import { checkbox } from './checkbox';

export const foreignborndocument = (data = {}) => {
  const processData = (data || {});
  return general('foreignborndocument', {
    DocumentType: radio(processData.DocumentType),
    ResidenceType: radio(processData.ResidenceType),
    CitizenType: radio(processData.CitizenType),
    OtherExplanation: textarea(processData.OtherExplanation),
    DocumentNumber: text(processData.DocumentNumber),
    DocumentNumberNotApplicable: notapplicable(processData.DocumentNumberNotApplicable),
    NoCertificateNumber: checkbox(processData.NoCertificateNumber), // PVQ Only
    CertificateNumber: text(processData.CertificateNumber),
    CertificateNumberNotApplicable: notapplicable(processData.CertificateNumberNotApplicable),
    DocumentExpiration: datecontrol(processData.DocumentExpiration),
    DocumentExpirationNotApplicable: notapplicable(processData.DocumentExpirationNotApplicable),
    DocumentExpirationUnknown: notapplicable(processData.DocumentExpirationUnknown),
    Comments: textarea(processData.Comments),
    LivesInUnitedStates: branch(processData.LivesInUnitedStates), // PVQ Only
    ResidenceTypeOtherExplanation: text(processData.ResidenceTypeOtherExplanation), // PVQ Only
  });
};
